class DataSourceAuthenticationDetailDto {

    Label: string;
    Name: string;
    ToEnter: boolean;
    ToGenerate: boolean;
    ToStore: boolean;
    IsSecret: boolean;
    IsRequired: boolean;

    constructor(label: string, name: string, toEnter: boolean, toGenerate: boolean, toStore: boolean, isSecret: boolean, isRequired: boolean) {
        this.Label = label;
        this.Name = name;
        this.ToEnter = toEnter;
        this.ToGenerate = toGenerate;
        this.ToStore = toStore;
        this.IsSecret = isSecret;
        this.IsRequired = isRequired;
    }
}

export default DataSourceAuthenticationDetailDto;